export { colorPalette } from './colorPalette'
export { formatCpf } from './formatCpf'
export { truncateText } from './truncateText'
export { hexToRgb } from './hexToRgb'
export { formatDate } from './formatDate'
export { formatMoney } from './formatMoney'
export { formatHour } from './formatHour'
export {
  feedTitleKeys,
  feedDescriptionKeys,
  productTypeKeys,
  proposalStepKeys,
  transformObjectEqualKeyAndValue,
} from './getKeysFromObject'
export { delay } from './delay'
export { isObject } from './isObject'
export * from './windowGlobal'
export * from './hasPermission'
